// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from "../common/public.js";
Vue.prototype.common = common;
import 'swiper/css/swiper.css'
import 'animate.css'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
import VueLazyLoad from "vue-lazyload";
import gImg from './common/img.js'
// var gImg = require("./common/img.js")
Vue.prototype.gImg = gImg
let language = window.localStorage.getItem("language") == null
  ? "cn"
  : window.localStorage.getItem("language")
Vue.prototype.language = language
import {
  WOW
} from 'wowjs'
import VueI18n from 'vue-i18n'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui';
import ViewUI from 'view-design';

import {
  Modal,
  Row,
  Col,
  Icon,
  Page,
  Collapse,
  Panel
} from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: window.localStorage.getItem('language') == null ? "cn" : window.localStorage.getItem('language'), // 语言标识
  messages: {
    'cn': require('@/assets/lang/zh'),
    'en': require('@/assets/lang/en')
  }
})
Vue.use(ElementUI);
Vue.use(VueLazyLoad, {
  preLoad: 1.3, // 预加载
  // error: gImg.index.spacing, // 错误时显示
  loading: gImg.arrow.Loading, //require("./assets/musicLogo.png")// 加载时显示
  attempt: 1 // 每次加载多少张
});
// Vue.use(VueAxios, axios)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.component('Modal', Modal);
Vue.component('Row', Row);
Vue.component('Col', Col);
Vue.component('Icon', Icon);
Vue.component('Page', Page);
Vue.component('Collapse', Collapse);
Vue.component('Panel', Panel);
Vue.config.productionTip = false
Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // default
  animateClass: 'animated', // default
  offset: 50, // default
  mobile: true, // default
  live: true, // default
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js